/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Modal,
  Button,
  Form,
  Dropdown,
  DropdownButton,
  Container,
  Row,
  Alert
} from 'react-bootstrap';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import useHttpApiCall from '../../services/useHttpApiCall';
import MachineStatusCustomizeContainer from '../machinestatus/containers/machine.status.customize.container';
import { setCustomiseButtonClick } from '../../redux/customiseValues/filterbutton/customiseButton';
import { useDispatch, useSelector } from 'react-redux';
import './style.css'

import ScheduleForm1 from "./createSchedule"
import ScheduleForm2 from "./addEquipmentToScedule";


const MyModal = ({ show, handleClose, formDataProps, isEdit, setHideModal }) => {
  const [selectedWeekdays, setSelectedWeekdays] = useState([]);
  const [selectedWeekdaysId, setSelectedWeekdaysId] = useState({});
  const [showToast, setShowToast] = useState(false);
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const [selectedItems, setSelectedItems] = useState([]);
  const [schedulePayload, setSchedulePayload] = useState([]);
  const [equipmentListPayload, setEquipmentListPayload] = useState('');
  const [equipmentList, setEquipmentList] = useState([]);

  const [selectedForm, setSelectedForm] = useState(1);
  const [openMachineStatusSlider, setOpenMachineStatusSlider] = useState(false);
  const [filterGraphId, setFilterGraphId] = useState(null);
  const [customiseModalVisibility, setCustomiseModalVisibility] = useState(false);
  const [enableNextButton, setEnableNextButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [customizeUpdate, setCustomizeUpdate] = useState({ filterGraphId: null, update: false });
    const [showErrors, setShowErrors] = useState(false);
  const customise_button_click = useSelector(
    (state) => state.customiseButtonClick.customise_button_click
  );
  // const [data] = useHttpApiCall(payloadSlideShows)
  // eslint-disable-next-line no-unused-vars
  const [data2, loading2, error2] = useHttpApiCall(schedulePayload);
  const [data] = useHttpApiCall(equipmentListPayload);
  const dispatch = useDispatch();
  const flexible_equipment = localStorage.getItem('flexible_equipment') == 'true' ? true : false;
  //const plantCode = localStorage.getItem('plantCode');

  const [scheduleParams, setScheduleParams] = useState();
  useEffect(() => {
    const hasName = scheduleParams?.name?.trim()?.length > 0;
    const hasWeekdays = selectedWeekdays?.length > 0;
    const fromTime = scheduleParams?.schedule_time?.[0]?.schedule_from_time;
    const toTime = scheduleParams?.schedule_time?.[0]?.schedule_to_time;
    const hasValidTimes = fromTime && toTime && fromTime < toTime;
    const hasStatus = !!scheduleParams?.machine_status;

    const isValid = hasName && hasWeekdays && hasValidTimes && hasStatus;

    setErrorMessage(!hasValidTimes);
    setEnableNextButton(isValid);
  }, [selectedWeekdays, scheduleParams]);

  // Add validation function
  const validateForm1 = () => {
    const hasName = scheduleParams?.name?.trim()?.length > 0;
    const hasWeekdays = selectedWeekdays?.length > 0;
    const fromTime = scheduleParams?.schedule_time?.[0]?.schedule_from_time;
    const toTime = scheduleParams?.schedule_time?.[0]?.schedule_to_time;
    const hasValidTimes = fromTime && toTime && fromTime < toTime;
    const hasStatus = !!scheduleParams?.machine_status;

    return hasName && hasWeekdays && hasValidTimes && hasStatus;
  };
    const handleNextClick = () => {
    setShowErrors(true); // Show validation messages
    
    if (validateForm1()) {
      handleLoadEquipmentList();
      setSelectedForm(2);
    }
  };

  useEffect(() => {
    
      setScheduleParams({
        name: '',
        machine_status: 'OFF',
        schedule_time: [
          {
            schedule_day: 1,
            schedule_from_time: '09:00:00',
            schedule_to_time: '10:00:00'
          }
        ]
      });
  }, [show]);
  
 // Initialize time states
 const [startTime, setStartTime] = useState(
  scheduleParams?.schedule_time?.[0]?.schedule_from_time?.slice(0, 5) || "09:00"
);
const [endTime, setEndTime] = useState(
  scheduleParams?.schedule_time?.[0]?.schedule_to_time?.slice(0, 5) || "10:00"
);

// Update time states when scheduleParams changes
useEffect(() => {
  if (scheduleParams?.schedule_time?.[0]) {
    setStartTime(scheduleParams.schedule_time[0].schedule_from_time?.slice(0, 5) || "09:00");
    setEndTime(scheduleParams.schedule_time[0].schedule_to_time?.slice(0, 5) || "10:00");
  }
}, [scheduleParams]);
  const handleCloseModal = () => {
    setSelectedForm(1);
    setHideModal();
    setShowToast(false);
    setOpenMachineStatusSlider(false)
    setSelectedWeekdays([]);
    setScheduleParams(
      formDataProps?.name
        ? formDataProps
        : {
            machine_status: 'OFF',
            schedule_time: [
              {
                schedule_day: 1,
                schedule_from_time: '09:00:00',
                schedule_to_time: '10:00:00'
              }
            ]
          }
    );
    handleClose();
  };
  useEffect(() => {
    setEquipmentList(data?.data?.data);
  }, [data]);
  const scheduleDaysParams = () => {
    let demo = ''; // Initialize an empty string
    demo = selectedWeekdays.join(',');

    return demo;
  };
  // Handle button click for weekdays
  const handleWeekdayClick = (day, index) => {
    setSelectedWeekdays((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        // Remove the index if it's already in the array
        return prevIndexes.filter((item) => item !== index);
      } else {
        // Add the index if it's not in the array
        return [...prevIndexes, index];
      }
    });
    // setSelectedWeekdays((prev)=>[...prev,index])
    // setWeekdays(prev => ({ ...prev, [day]: !prev[day] }));
    setEnableNextButton(selectedWeekdays.length > 0 ? true : false);
  };
  const handleLoadEquipmentList = () => {
    flexible_equipment
      ? setEquipmentListPayload({
          auth: true,
          url: `v1/layers/equipments/`,
          params: {
            //plant_code: plantCode,
            layer_type: 'company',
            equipment_type: 1,
            is_shop_floor_view: 1,
            schedule_days: scheduleDaysParams(),
            // machine_status_condition:scheduleParams?.machine_status_condition?'SHOULD_BE':'SHOULD_NOT_BE',
            schedule_from: scheduleParams?.schedule_time[0]?.schedule_from_time,
            schedule_to: scheduleParams?.schedule_time[0]?.schedule_to_time,
            schedule_id:scheduleParams?.id
          }
        })
      : setEquipmentListPayload({
          auth: true,
          url: 'v0/equipments/',
          params: {
            equipment_type: 1,
            is_shop_floor_view: 1,
            schedule_days: scheduleDaysParams(),
            // machine_status_condition:scheduleParams?.machine_status_condition?'SHOULD_BE':'SHOULD_NOT_BE',
            schedule_from: scheduleParams?.schedule_time[0]?.schedule_from_time,
            schedule_to: scheduleParams?.schedule_time[0]?.schedule_to_time,
            schedule_id:scheduleParams?.id
          }
        });
  };
  useEffect(() => {
    formDataProps?.name && setScheduleParams(formDataProps);
    // setSelectedWeekdays(formDataProps?.equipment_id?.length>0?formDataProps?.schedule_time?.map((item)=>{return item?.equipment_id }):[])
    setSelectedWeekdays(
      formDataProps?.schedule_time?.length > 0
        ? formDataProps?.schedule_time?.map((item) => {
            return item?.schedule_day;
          })
        : []
    );
    setSelectedItems(
      formDataProps?.schedule_equipment?.length > 0
        ? formDataProps?.schedule_equipment?.map((item) => {
            return item?.equipment_id;
          })
        : []
    );
    setScheduleParams((prevState) => ({
      ...prevState,
      machine_status_condition: formDataProps?.machine_status_condition == 'SHOULD_BE'
    }));
    setSelectedWeekdaysId(
      formDataProps?.schedule_time?.reduce((days, { schedule_day, id }) => {
        days[schedule_day] = id;
        return days;
      }, {})
    );
  }, [formDataProps]);
  useEffect(() => {
    if (data2 && data2?.data) {
      if (data2 && data2) {
        if (data2?.data?.status == 1) {
          // setShowToast(false)
          handleCloseModal();
        } else if (data2[1] == true) {
          setShowToast(true);
        }
      }
    }
  }, [data2, error2, loading2]);
  const handleSubmit = () => {
    const scheduleTime = selectedWeekdays?.map((item, index) => {
      return selectedWeekdaysId?.[item]
        ? {
            id: selectedWeekdaysId[item],
            schedule_day: item,
            schedule_from_time: scheduleParams?.schedule_time[0]?.schedule_from_time,
            schedule_to_time: scheduleParams?.schedule_time[0].schedule_to_time
          }
        : {
            schedule_day: item,
            schedule_from_time: scheduleParams?.schedule_time[0]?.schedule_from_time,
            schedule_to_time: scheduleParams?.schedule_time[0].schedule_to_time
          };
    });
    isEdit
      ? setSchedulePayload({
          auth: true,
          url: `v0/shop-floor-view/schedules/${scheduleParams?.id}/`,
          method: 'PATCH',
          data: {
            name: scheduleParams?.name,
            is_active: scheduleParams?.is_active,
            machine_status: scheduleParams?.machine_status,
            machine_status_condition: scheduleParams?.machine_status_condition
              ? 'SHOULD_BE'
              : 'SHOULD_NOT_BE',
            tagged_equipment: selectedItems,
            schedule_time: scheduleTime
          }
        })
      : setSchedulePayload({
          auth: true,
          url: 'v0/shop-floor-view/schedules/',
          method: 'POST',
          data: {
            name: scheduleParams?.name,
            is_active: scheduleParams?.is_active,
            machine_status: scheduleParams?.machine_status,
            machine_status_condition: scheduleParams?.machine_status_condition
              ? 'SHOULD_BE'
              : 'SHOULD_NOT_BE',
            tagged_equipment: selectedItems,
            schedule_time: scheduleTime
          }
        });
    // handleClose()
  };
 // Handle time change with 2-minute interval enforcement
const handleTimeChange = (time, timeType) => {
  let formattedTime = "00:00:00";
  let displayTime = "00:00"; // For the picker display
  
  if (time) {
    // Split the time and ensure 2-minute intervals
    const [hours, minutes] = time.split(':');
    const minutesNum = parseInt(minutes, 10);
    
    // Round to nearest 2-minute interval
    const roundedMinutes = Math.round(minutesNum / 2) * 2;
    
    // Create the formatted times
    formattedTime = `${hours.padStart(2, '0')}:${String(roundedMinutes).padStart(2, '0')}:00`;
    displayTime = `${hours.padStart(2, '0')}:${String(roundedMinutes).padStart(2, '0')}`;
  }
  
  // Update the schedule parameters
  setScheduleParams(prevState => {
    const updatedScheduleTime = [...prevState.schedule_time];
    updatedScheduleTime[0] = {
      ...updatedScheduleTime[0],
      [timeType]: formattedTime
    };
    return {
      ...prevState,
      schedule_time: updatedScheduleTime
    };
  });
  
  // Update local state for the time picker display
  if (timeType === 'schedule_from_time') {
    setStartTime(displayTime);
  } else {
    setEndTime(displayTime);
  }
};
  // Handle status selection
  // const handleStatusChange = (newStatus) => {
  //   setStatus(newStatus);
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setScheduleParams((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };
  const IntervalTimePicker = ({ value, onChange, id }) => {
  // Generate time options with 2-minute intervals
  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 2) {
      const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      timeOptions.push(timeString);
    }
  }

  return (
    <Form.Select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="form-select"
    >
      {timeOptions.map((time) => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </Form.Select>
  );
};
  const handleDropdownChange = (e) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    // const { name,value } = e?.target;
    setScheduleParams((prevState) => ({
      ...prevState,
      machine_status: e
    }));
  };
  const truncateText = (text, maxLength) => {
    // If the text length exceeds the max length, truncate and add "..."
    if (text?.length > maxLength) {
      return text.slice(0, maxLength) + '...';
    }
    return text;
  };
// Instead of relying on e.target.checked
const handleItemClick = (checked, item) => {
  if (checked) {
    setSelectedItems((prev) => [...prev, item.id]);
  } else {
    setSelectedItems((prev) => prev.filter((id) => id !== item.id));
  }
};

  const handleAddMachineStatusClick = (item) => {
    setOpenMachineStatusSlider(true);
    setCustomiseModalVisibility(true);
    dispatch(setCustomiseButtonClick(item));
  };
  return (
 <div   className="scheduleFormModel">
  <Modal
  className="scheduleForm"
    show={show}
    onHide={handleCloseModal}
    backdrop="static"
    keyboard={false}
    centered
  >
   {openMachineStatusSlider && (
          <MachineStatusCustomizeContainer
            openMachineStatusSlider={openMachineStatusSlider}
            processDetails={{
              ShopFloorView: true,
              drilldownlevel: 'Process',
              process_type: 'Production',
              process_id: customise_button_click?.process,
              sub_process_id: customise_button_click?.sub_process_id,
              equipment_id: customise_button_click?.equipment_id,
              layer_id: customise_button_click?.layer_id,
              layer_type: customise_button_click?.layer_type,
              plant_code: customise_button_click?.plant_code
            }}
            setOpenMachineStatusSlider={setOpenMachineStatusSlider}
            setCustomizeUpdate={setCustomizeUpdate}
            filterGraphId={filterGraphId}
            handleClose={() => {
              handleLoadEquipmentList();
              // setEquipmentListPayload(prev => ({...prev, timestamp: Date.now()}));
            }}
          />
        )}
    



   

<Modal.Body>
  <Alert
    className="sidebar-slider_alert"
    show={showToast}
    variant="danger"
    onClose={() => setShowToast(false)}
  >
    <p className="text-center">Error while creating schedule</p>
  </Alert>

  {selectedForm === 1 ? (
    <ScheduleForm1
      scheduleParams={scheduleParams}
      handleChange={handleChange}
      selectedWeekdays={selectedWeekdays}
      daysOfWeek={daysOfWeek}
      handleWeekdayClick={handleWeekdayClick}
      startTime={startTime}
      endTime={endTime}
      handleTimeChange={handleTimeChange}
      errorMessage={errorMessage}
      handleDropdownChange={handleDropdownChange}
      IntervalTimePicker={IntervalTimePicker}
      handleCloseModal={handleCloseModal}
    />
  ) : (
    <ScheduleForm2
      equipmentList={equipmentList}
      truncateText={truncateText}
      handleAddMachineStatusClick={handleAddMachineStatusClick}
      selectedItems={selectedItems}
      handleItemClick={handleItemClick}
      handleCloseModal={handleCloseModal}
    />
  )}
</Modal.Body>

    <Modal.Footer
  className={`w-100 ${
    selectedForm === 1 ? "justify-content-center" : "justify-content-between"
  }`}
>
  {selectedForm === 1 ? (
    // Step 1 → Only Next button, centered
    <Button
      variant="primary"
      className="btn-grad"
      disabled={!enableNextButton}
        onClick={handleNextClick}

    >
      Next
    </Button>
  ) : (
    // Step 2 → Back + Save Changes
    <>
      <Button
        variant="secondary"
        onClick={() => {setSelectedForm(1);
           setShowErrors(false); // Reset errors when going back
        }}
      >
        Back
      </Button>
      <Button
        variant="primary"
        className="btn-grad"
        onClick={handleSubmit}
      >
        Save Changes
      </Button>
    </>
  )}
</Modal.Footer>

      </Modal>
    </div>
  );
};

export default MyModal;

